export default class BackLink {
    constructor(el) {
        if (!document.referrer)
            return;
        el.addEventListener('click', (e) => {
            e.preventDefault();
            history.back();
        });
    }
}
